import InnerComponent from '@Components/Purchase/DebitNotes';
import orgContainer from '@Components/AppContainer';

const ListDebitNotePage = () => ((orgContainer(InnerComponent)));
export default ListDebitNotePage;
